import { render, staticRenderFns } from "./AppDownloadToType.vue?vue&type=template&id=47de0377&scoped=true&"
import script from "./AppDownloadToType.vue?vue&type=script&lang=js&"
export * from "./AppDownloadToType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47de0377",
  null
  
)

export default component.exports